import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// jsPDF verwendet standardmäßig Latin-1 — Umlaute müssen ersetzt werden
function u(s) {
  if (!s) return s;
  return String(s)
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
    .replace(/Ä/g, 'Ae').replace(/Ö/g, 'Oe').replace(/Ü/g, 'Ue')
    .replace(/ß/g, 'ss').replace(/–/g, '-').replace(/„/g, '"').replace(/"/g, '"');
}

function fmt(d) {
  if (!d) return '–';
  if (d.includes('-') && d.length === 10) {
    const [y, m, day] = d.split('-');
    return `${day}.${m}.${y}`;
  }
  return d;
}

function fmtKm(v) {
  if (!v) return '–';
  return Number(v).toLocaleString('de-DE') + ' km';
}

function fmtEur(v) {
  if (!v) return '–';
  return Number(v).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

function today() {
  return new Date().toLocaleDateString('de-DE');
}

function addHeader(doc, title, subtitle) {
  doc.setFillColor(26, 79, 160);
  doc.rect(0, 0, 210, 18, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text(u(title), 14, 12);
  if (subtitle) {
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text(u(subtitle), 14, 17.5);
  }
  doc.setTextColor(0, 0, 0);
  return 26;
}

function addSection(doc, y, title) {
  if (y > 260) { doc.addPage(); y = 20; }
  doc.setFillColor(243, 244, 246);
  doc.rect(14, y, 182, 7, 'F');
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(55, 65, 81);
  doc.text(u(title), 16, y + 5);
  doc.setTextColor(0, 0, 0);
  return y + 10;
}

function addKVTable(doc, y, rows) {
  const validRows = rows.filter(r => r[1] && r[1] !== '–').map(r => [u(r[0]), u(r[1])]);
  if (validRows.length === 0) return y + 2;
  autoTable(doc, {
    startY: y,
    body: validRows,
    theme: 'plain',
    styles: { fontSize: 9, cellPadding: 2 },
    columnStyles: {
      0: { fontStyle: 'bold', textColor: [107, 114, 128], cellWidth: 55 },
      1: { textColor: [17, 24, 39] }
    },
    margin: { left: 14, right: 14 },
  });
  return doc.lastAutoTable.finalY + 4;
}

function addFooter(doc) {
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(156, 163, 175);
    doc.text(`Fuhrparkverwaltung · Stand: ${today()} · Seite ${i}/${pageCount}`, 14, 290);
  }
}

// ─── Export 1: Fahrzeugdetail ────────────────────────────────────────────────

export function exportFahrzeugDetail(fahrzeug, radsaetze = [], kontakte = []) {
  const doc = new jsPDF();
  const title = fahrzeug.kennzeichen + (fahrzeug.marke ? ` – ${fahrzeug.marke}${fahrzeug.modell ? ' ' + fahrzeug.modell : ''}` : '');
  let y = addHeader(doc, 'Fahrzeugdetail', title);

  y = addSection(doc, y, 'Fahrzeugdaten');
  y = addKVTable(doc, y, [
    ['Fahrzeugtyp', fahrzeug.fahrzeugtyp],
    ['Kennzeichen', fahrzeug.kennzeichen],
    ['Marke / Modell', [fahrzeug.marke, fahrzeug.modell].filter(Boolean).join(' ') || null],
    ['Farbe', fahrzeug.farbe],
    ['FIN', fahrzeug.fin],
    ['Erstzulassung', fmt(fahrzeug.erstzulassung)],
    ['Kraftstoffart', fahrzeug.kraftstoffart],
    ['Kilometerstand', fmtKm(fahrzeug.kilometerstand)],
    ['Kunde', fahrzeug.kunden_name],
  ]);

  y = addSection(doc, y, 'Prüftermine & Inspektion');
  y = addKVTable(doc, y, [
    ['HU-Fälligkeit', fmt(fahrzeug.hu_faelligkeit)],
    ['SP-Fälligkeit', fmt(fahrzeug.sp_faelligkeit)],
    ['Nächste Inspektion', fmt(fahrzeug.naechste_inspektion_datum)],
    ['Inspektion bei km', fmtKm(fahrzeug.naechste_inspektion_km)],
  ]);

  if (fahrzeug.versicherungsgesellschaft || fahrzeug.versicherungsart || fahrzeug.versicherungsablauf) {
    y = addSection(doc, y, 'Versicherung');
    y = addKVTable(doc, y, [
      ['Gesellschaft', fahrzeug.versicherungsgesellschaft],
      ['Versicherungsnummer', fahrzeug.versicherungsnummer],
      ['Art', fahrzeug.versicherungsart],
      ['Ablauf', fmt(fahrzeug.versicherungsablauf)],
    ]);
  }

  if (fahrzeug.finanzierungsart) {
    y = addSection(doc, y, 'Finanzierung / Leasing');
    y = addKVTable(doc, y, [
      ['Art', fahrzeug.finanzierungsart],
      ['Anbieter / Bank', fahrzeug.finanzierungsanbieter],
      ['Monatliche Rate', fmtEur(fahrzeug.monatliche_rate)],
      ['Vertragsbeginn', fmt(fahrzeug.vertragsbeginn)],
      ['Vertragsende', fmt(fahrzeug.vertragsende)],
      ['Bereifung', fahrzeug.leasing_bereifung === '8' ? '8-fach (zwei Sätze) – Rückgabe erforderlich' : fahrzeug.leasing_bereifung === '4' ? '4-fach (ein Satz)' : null],
      ['Laufleistung Vertrag', fmtKm(fahrzeug.leasing_km_gesamt)],
      ['km-Stand Vertragsbeginn', fmtKm(fahrzeug.leasing_km_start)],
    ]);
  }

  if (radsaetze.length > 0) {
    y = addSection(doc, y, `Radsätze (${radsaetze.length})`);
    autoTable(doc, {
      startY: y,
      head: [['Art', 'Marke', 'Größe', 'Profil', 'Zustand', 'Status', 'Lagerort']],
      body: radsaetze.map(r => [
        u(r.reifenart) || '–',
        u(r.reifenmarke) || '–',
        u(r.reifengroesse) || '–',
        r.profiltiefe ? r.profiltiefe + ' mm' : '–',
        u(r.zustand) || '–',
        r.montiert ? 'Montiert' : r.fremdeingelagert ? 'Fremdlager' : 'Eingelagert',
        u(r.lagerort_name || r.einlagerungsort) || '–',
      ]),
      theme: 'striped',
      styles: { fontSize: 8 },
      headStyles: { fillColor: [26, 79, 160] },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 4;
  }

  if (kontakte.length > 0) {
    y = addSection(doc, y, 'Zugeordnete Kontakte');
    autoTable(doc, {
      startY: y,
      head: [['Name', 'Betrieb', 'Telefon', 'Mobil', 'E-Mail']],
      body: kontakte.map(k => [
        k.name,
        k.betriebe && k.betriebe.length > 0 ? k.betriebe.map(b => b.name).join(', ') : '–',
        k.telefon || '–',
        k.mobil || '–',
        k.email || '–',
      ]),
      theme: 'striped',
      styles: { fontSize: 8 },
      headStyles: { fillColor: [26, 79, 160] },
      margin: { left: 14, right: 14 },
    });
  }

  if (fahrzeug.notizen) {
    y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : y) + 4;
    y = addSection(doc, y, 'Notizen');
    doc.setFontSize(9);
    doc.setTextColor(55, 65, 81);
    const lines = doc.splitTextToSize(u(fahrzeug.notizen), 182);
    doc.text(lines, 14, y);
  }

  addFooter(doc);
  doc.save(`Fahrzeug_${fahrzeug.kennzeichen.replace(/\s/g, '_')}.pdf`);
}

// ─── Export 2: Kunden-Fahrzeuge ──────────────────────────────────────────────

export function exportKundenFahrzeuge(kunde, fahrzeuge) {
  const doc = new jsPDF({ orientation: 'landscape' });
  let y = addHeader(doc, `Fahrzeugübersicht – ${kunde.name}`, `${fahrzeuge.length} Fahrzeug(e) · Stand: ${today()}`);

  autoTable(doc, {
    startY: y,
    head: [['Kennzeichen', 'Typ', 'Marke / Modell', 'km-Stand', 'HU fällig', 'SP fällig', 'Inspektion', 'Versicherung', 'Finanzierung']],
    body: fahrzeuge.map(f => [
      u(f.kennzeichen),
      u(f.fahrzeugtyp) || '–',
      u([f.marke, f.modell].filter(Boolean).join(' ')) || '–',
      fmtKm(f.kilometerstand),
      fmt(f.hu_faelligkeit),
      fmt(f.sp_faelligkeit),
      fmt(f.naechste_inspektion_datum),
      fmt(f.versicherungsablauf),
      u(f.finanzierungsart) || '–',
    ]),
    theme: 'striped',
    styles: { fontSize: 8 },
    headStyles: { fillColor: [37, 99, 235] },
    margin: { left: 14, right: 14 },
  });

  addFooter(doc);
  doc.save(`Fahrzeuge_${kunde.name.replace(/\s/g, '_')}.pdf`);
}

// ─── Export 3: Fälligkeiten ──────────────────────────────────────────────────

export function exportFaelligkeiten(warnungen) {
  const doc = new jsPDF({ orientation: 'landscape' });
  let y = addHeader(doc, 'Fälligkeitsübersicht', `${warnungen.length} Einträge · Stand: ${today()}`);

  autoTable(doc, {
    startY: y,
    head: [['Kennzeichen', 'Fahrzeug', 'Kunde', 'Typ', 'Fällig am / Info', 'Status', 'Kontakt', 'Telefon']],
    body: warnungen.map(w => [
      u(w.kennzeichen),
      u([w.marke, w.modell].filter(Boolean).join(' ')) || '–',
      u(w.kunden_name),
      u(w.typ),
      w.typ === 'Leasing-km'
        ? (w.leasing_info ? `Hochr. ${w.leasing_info.km_hochgerechnet?.toLocaleString('de-DE')} km` : '–')
        : fmt(w.datum),
      w.ueberfaellig ? 'Ueberfaellig' : `In ${w.diffDays} Tagen`,
      w.kontakt ? u(w.kontakt.name) : '–',
      w.kontakt ? (w.kontakt.telefon || w.kontakt.mobil || '–') : '–',
    ]),
    theme: 'striped',
    styles: { fontSize: 8 },
    headStyles: { fillColor: [220, 38, 38] },
    didParseCell: (data) => {
      if (data.section === 'body' && data.column.index === 5) {
        const val = data.cell.raw;
        if (val === 'Überfällig') data.cell.styles.textColor = [220, 38, 38];
      }
    },
    margin: { left: 14, right: 14 },
  });

  addFooter(doc);
  doc.save(`Faelligkeiten_${today().replace(/\./g, '-')}.pdf`);
}

// ─── Export 4: Radsatz-Übersicht ─────────────────────────────────────────────

export function exportRadsaetzeUebersicht(radsaetze) {
  const doc = new jsPDF({ orientation: 'landscape' });
  let y = addHeader(doc, 'Radsatz-Übersicht', `${radsaetze.length} Radsätze · Stand: ${today()}`);

  autoTable(doc, {
    startY: y,
    head: [['Fahrzeug', 'Kunde', 'Reifenart', 'Marke', 'Größe', 'Profiltiefe', 'Zustand', 'Status', 'Lagerort']],
    body: radsaetze.map(r => [
      u(r.kennzeichen),
      u(r.kunden_name),
      u(r.reifenart) || '–',
      u(r.reifenmarke) || '–',
      u(r.reifengroesse) || '–',
      r.profiltiefe ? r.profiltiefe + ' mm' : '–',
      u(r.zustand) || '–',
      r.montiert ? 'Montiert' : r.fremdeingelagert ? 'Fremdlager' : 'Eingelagert',
      u(r.lagerort_name || r.einlagerungsort) || '–',
    ]),
    theme: 'striped',
    styles: { fontSize: 8 },
    headStyles: { fillColor: [37, 99, 235] },
    didParseCell: (data) => {
      if (data.section === 'body' && data.column.index === 5 && data.cell.raw) {
        const val = parseFloat(String(data.cell.raw).replace(' mm', '').replace(',', '.'));
        const art = data.row.raw[2];
        if (!isNaN(val) && ((art === 'Sommerreifen' && val < 3) || (val < 5)))
          data.cell.styles.textColor = [220, 38, 38];
      }
    },
    margin: { left: 14, right: 14 },
  });

  addFooter(doc);
  doc.save(`Radsaetze_${today().replace(/\./g, '-')}.pdf`);
}
